<template>
  <yxtf-dialog
    :title="$t('pc_biz_lbl_newfolder'/** 新建文件夹 */)"
    :visible.sync="visible"
    append-to-body
    :before-close="beforeClose"
    width="520px"
    @close="close"
  >
    <yxtf-form
      ref="form"
      :model="ruleForm"
      :rules="rules"
      label-width="90px"
      :label-position="labelPosition"
      :show-message="false"
    >
      <!-- 上级文件夹 -->
      <yxtf-form-item prop="parentId" :label="$t('pc_biz_lbl_parentfolder'/** 上级文件夹 */)">
        {{ parentName }}
      </yxtf-form-item>
      <!-- 名称 -->
      <yxtf-form-item prop="libName" :label="$t('pc_biz_lbl_foldername'/** 文件夹名称 */)">
        <yxtf-input
          v-model.trim="ruleForm.libName"
          maxlength="50"
          show-word-limit
          :placeholder="$t('pc_biz_lbl_folderplaceholder'/** 请输入文件夹名称 */)"
          @keyup.enter.prevent
        />
      </yxtf-form-item>
    </yxtf-form>
    <template slot="footer">
      <!-- <yxtf-button plain @click="visible = false">{{ $t('pc_biz_core_btn_cancel') }}</yxtf-button> -->
      <CancelButton @click="visible = false" />
      <yxtf-button type="primary" :loading="loading" @click="save">{{ $t('pc_biz_core_btn_confirm') }}</yxtf-button>
    </template>
  </yxtf-dialog>
</template>

<script>
import CancelButton from './cancelButton';
import { addEditKngLib } from '../service.js';
export default {
  name: '',
  inject: ['toast'],
  components: { CancelButton },
  props: {
    labelPosition: String
  },
  data() {
    return {
      visible: false,
      loading: false,
      parentName: '',
      ruleForm: {
        libName: '',
        parentId: ''
      },
      rules: {
        libName: [
          { required: true, message: '', trigger: 'blur' }
        ]
      }
    };
  },
  methods: {
    // 初始化弹框
    init(data) {
      this.visible = true;
      this.$nextTick(() => {
        this.ruleForm.parentId = data.id;
        this.parentName = data.label;
      });
      return new Promise((resolve) => {
        this.resolve = resolve;
      });
    },
    // 保存
    save() {
      this.$refs.form.validate().then(() => {
        this.loading = true;
        addEditKngLib(this.ruleForm).then(res => {
          this.toast(this.$t('pc_biz_msg_createsuccess'/** 新建成功 */));
          this.resolve({ ...this.ruleForm, ...res });
          this.visible = false;
        }).catch(e => {
          this.toast(e, 'error');
        }).then(() => {
          this.loading = false;
        });
      }).catch(() => {});
    },
    beforeClose(done) {
      if (!this.ruleForm.libName) {
        return done();
      }
      this.$confirm(this.$t('pc_biz_core_msg_confirmcancletip'/** 当前操作尚未保存，是否确认取消？ */), this.$t('pc_biz_core_msg_cancel'/** 确认取消？ */), {
        confirmButtonText: this.$t('pc_biz_core_btn_confirm'),
        cancelButtonText: this.$t('pc_biz_core_btn_cancel'),
        type: 'warning'
      }).then(() => {
        done();
      }).catch(() => {});
    },
    close() {
      this.loading = false;
      this.resolve = null;
      this.$refs.form.resetFields();
    }
  }
};
</script>
